<template>
  <body class="body">
    <div class="container" id="formContent">
      <div>
        <img style="width: 40%;" src="../img/teste.png"/>
      </div>

      <div>
        <router-link :to="`/classes/5`">
          <button type="button" class="buton btn">
            Clasa a 5-a
          </button>
        </router-link>
      </div>

      <div>
        <router-link :to="`/classes/6`">
          <button type="button" class="buton btn">
            Clasa a 6-a
          </button>
        </router-link>
      </div>

      <div>
        <router-link :to="`/classes/7`">
          <button type="button" class="buton btn">
            Clasa a 7-a
          </button>
        </router-link>
      </div>

      <div>
        <router-link :to="`/classes/8`">
          <button type="button" class="buton btn">
            Clasa a 8-a
          </button>
        </router-link>
      </div>
    </div>
  </body>
</template>

<script>
export default {
  name: 'Classes',
}
</script>

<style scoped>
.body {
 background-color: #FBEFDA;
 display: flex;
 align-content: center;
 justify-content: center;
 flex-direction: column;
 height: 100%;
}

.buton {
  margin-top: 1%;
}

.container {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
}

#formContent {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 80%;
  height: fit-content;
  position: relative;
  -webkit-box-shadow: 0 10px 10px 0 rgba(0,0,0,0.3);
  box-shadow: 0 10px 10px 0 rgba(0,0,0,0.3);
  text-align: center;
}
</style>
